import {useMutation} from '@tanstack/react-query';
import {ReactNode, useEffect, useState} from 'react';
import {viewerMutationAdapter} from '../../../../../../adapter/viewerMutationAdapter';
import {requestContext} from '../../../../../../common/requestContext';

export function ViewerOpenPageFetcherHeadless({
  seriesId,
  productId,
  ticketUid,
  children,
}: {
  seriesId: number;
  productId: number;
  ticketUid?: string;
  children?: ReactNode;
}) {
  const {mutateAsync: openPage} = useMutation(viewerMutationAdapter.openPage());
  const [error, setError] = useState<Error | undefined>();
  useEffect(() => {
    // KW-6530 웹뷰인 경우 이중으로 open_page 가 호출되기 때문에 웹에선 전송하지 않습니다
    if (requestContext.requestInfo.display.isWebView) {
      return;
    }
    let isMounted = true;
    openPage({
      input: {
        seriesId,
        productId,
        ticketUid,
      },
    }).catch(e => {
      if (isMounted) {
        setError(e);
      }
    });
    return () => {
      isMounted = false;
    };
  }, [openPage, seriesId, productId, ticketUid]);

  if (error) {
    throw error;
  }
  if (!children) {
    return null;
  }
  return <>{children}</>;
}
